const SERVICES = [
  {
    icon: 'ri-layout-grid-line',
    title: 'Tile Walls & Floors',
    tag: 'Foundation of Every Remodel',
    desc: 'Large-format, mosaic, or classic — we install tile with perfect alignment, consistent grout joints, and a finish that stands up to daily use for decades.',
    features: ['Large-format tile', 'Mosaic & pattern work', 'Floor-to-ceiling walls', 'Waterproof membrane underneath'],
    image: 'https://public.readdy.ai/ai/img_res/504a58487186feccdd87bbaeefdcaed5.jpg',
  },
  {
    icon: 'ri-drop-line',
    title: 'Shower Remodels',
    tag: 'Most Requested',
    desc: 'From full tear-out to walk-in conversions — every shower we build is properly waterproofed, sloped, and finished with precision. No leaks. No callbacks.',
    features: ['Full demo & rebuild', 'Walk-in conversions', 'Niche & bench installation', 'Frameless glass enclosures'],
    image: 'https://readdy.ai/api/search-image?query=luxury%20walk-in%20shower%20remodel%20with%20large%20grey%20stone%20tiles%2C%20frameless%20glass%20door%2C%20built-in%20tile%20niche%20with%20products%2C%20rainfall%20shower%20head%2C%20clean%20modern%20design%2C%20premium%20residential%20bathroom%20renovation%2C%20beautiful%20finished%20shower%20installation&width=600&height=420&seq=bath_shower001&orientation=landscape',
  },
  {
    icon: 'ri-home-gear-line',
    title: 'Vanity & Layout Upgrades',
    tag: 'Instant Impact',
    desc: 'New vanity, updated layout, better storage. We handle the plumbing rough-in coordination, tile work, and finishing so everything lines up perfectly.',
    features: ['Floating vanity install', 'Double sink upgrades', 'Mirror & lighting framing', 'Custom tile backsplash'],
    image: 'https://readdy.ai/api/search-image?query=modern%20bathroom%20vanity%20area%20with%20floating%20double%20sink%20vanity%20in%20dark%20charcoal%20wood%2C%20large%20bathroom%20mirror%20with%20warm%20LED%20lighting%2C%20white%20subway%20tile%20backsplash%2C%20clean%20contemporary%20bathroom%20design%2C%20premium%20residential%20renovation%20result&width=600&height=420&seq=bath_vanity001&orientation=landscape',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Complete Renovations',
    tag: 'Full Transformation',
    desc: 'Start-to-finish bathroom transformation. We gut the space, resolve any structural or water issues we find, and rebuild it to a modern, functional standard.',
    features: ['Full demo included', 'Subfloor repair if needed', 'All trades coordinated', 'Single point of contact'],
    image: 'https://readdy.ai/api/search-image?query=completely%20renovated%20modern%20luxury%20bathroom%20transformation%2C%20white%20and%20beige%20natural%20stone%20tiles%20throughout%2C%20freestanding%20soaking%20bathtub%2C%20large%20walk-in%20shower%2C%20ambient%20warm%20lighting%2C%20premium%20residential%20full%20bathroom%20renovation%20completed%2C%20beautiful%20contemporary%20design&width=600&height=420&seq=bath_full001&orientation=landscape',
  },
];

export default function BathroomServices() {
  return (
    <section className="py-24 px-4 md:px-8 bg-[#111111] border-t border-white/8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.3em] mb-4">What We Do</p>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-5">Bathroom Services</h2>
          <p className="text-white/45 text-base max-w-xl mx-auto leading-relaxed">
            Every service executed with the same standard — precise, clean, and built to last.
            No shortcuts in a room where water is involved.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((service) => (
            <div
              key={service.title}
              className="group bg-[#1a1a1a] border border-white/8 hover:border-[#c9a55a]/30 rounded-2xl overflow-hidden transition-all duration-300"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-transparent to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="bg-[#c9a55a] text-[#0d0d0d] text-xs font-bold px-3 py-1.5 rounded-full whitespace-nowrap">
                    {service.tag}
                  </span>
                </div>
              </div>

              <div className="p-8">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#c9a55a]/10 rounded-xl">
                    <i className={`${service.icon} text-[#c9a55a] text-lg`} />
                  </div>
                  <h3 className="text-white font-black text-xl">{service.title}</h3>
                </div>
                <p className="text-white/50 text-sm leading-relaxed mb-6">{service.desc}</p>
                <div className="grid grid-cols-2 gap-2">
                  {service.features.map((f) => (
                    <div key={f} className="flex items-center gap-2">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-[#c9a55a] text-xs" />
                      </div>
                      <span className="text-white/55 text-xs">{f}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
